import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { CalendarPlus } from "lucide-react";
import { downloadIcs, googleCalendarUrl, outlookCalendarUrl } from "@/lib/addToCalendar";

// Dropdown button that lets a user add an event/meet-up to Google Calendar,
// Apple Calendar (.ics) or Outlook. Safe to drop inside clickable parent
// elements — all handlers stopPropagation + preventDefault.
export function AddToCalendarButton({
  event,
  size = "sm",
  variant = "outline",
  className = "",
  label = "Add to calendar",
  testIdSuffix = "",
}) {
  const stop = (e) => { if (e) { e.preventDefault?.(); e.stopPropagation?.(); } };
  const openGoogle = (e) => { stop(e); window.open(googleCalendarUrl(event), "_blank", "noopener,noreferrer"); };
  const openOutlook = (e) => { stop(e); window.open(outlookCalendarUrl(event), "_blank", "noopener,noreferrer"); };
  const openApple = (e) => { stop(e); downloadIcs(event); };
  const tid = testIdSuffix ? `-${testIdSuffix}` : "";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          size={size}
          variant={variant}
          className={`rounded-full border-sage/40 ${className}`}
          onClick={stop}
          data-testid={`add-to-calendar-btn${tid}`}
        >
          <CalendarPlus className="w-4 h-4 mr-1" /> {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-white border border-sage/30 rounded-xl shadow-md min-w-[200px]"
        onClick={stop}
      >
        <DropdownMenuItem onClick={openGoogle} className="cursor-pointer" data-testid={`add-to-calendar-google${tid}`}>
          Google Calendar
        </DropdownMenuItem>
        <DropdownMenuItem onClick={openApple} className="cursor-pointer" data-testid={`add-to-calendar-apple${tid}`}>
          Apple Calendar (.ics)
        </DropdownMenuItem>
        <DropdownMenuItem onClick={openOutlook} className="cursor-pointer" data-testid={`add-to-calendar-outlook${tid}`}>
          Outlook
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
